module.exports = __webpack_public_path__ + "img/we-title.ca4f9bec.png";